import cx from 'classnames'
import React from 'react'
import PropTypes from 'prop-types'

import { isMobileWidth } from '@cred/shared/utils'

import ratingStar from 'mortgage-combined/assets/icons/rating-star.svg'
import HelpIconWithModal from 'components/help-icon-with-modal'

import styles from './CredibleRating.module.scss'
import CredibleRatingModal from './CredibleRatingModal'

const isMobile = isMobileWidth()

const CredibleRating = ({ className, rating, loadingClassName, id }) => {
  return (
    <div className={cx(styles.rating, className, loadingClassName)}>
      <img src={ratingStar} alt="rating-star" />
      <p className="bodySmall semiBold">{rating || 'NA'}</p>
      <p className="disclaimer neutral500">Credible rating</p>
      <HelpIconWithModal
        sdkScroll
        modalName={`credible-rating-${id}`}
        isMobile={isMobile}
        color="secondary500"
        smallGreyIcon={styles.smallGreyIcon}
        modalComponent={CredibleRatingModal}
      />
    </div>
  )
}

CredibleRating.propTypes = {
  className: PropTypes.string,
  loadingClassName: PropTypes.string,
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

export default CredibleRating
